import React, { useState } from 'react';
import useTranslation from '../hooks/useTranslation';
import { authFetch, authHeaders } from '../utils/authFetch';

const API_HOST = (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'))
  ? 'http://localhost:8000'
  : 'https://app.neurolonic.com/api';

export default function ResetPasswordModal({ open, onClose }) {
  const { t } = useTranslation();
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  async function handleSavePassword() {
    setError("");
    setSuccess("");
    const userId = localStorage.getItem("neuro_user_id");
    if (!password1 || !password2) {
      setError("Please fill in both fields.");
      return;
    }
    if (password1 !== password2) {
      setError("Passwords do not match.");
      return;
    }
    try {
      const res = await authFetch(`${API_HOST}/user/${userId}/password`, {
        method: 'PUT',
        headers: { ...authHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ new_password: password1 })
      });
      const data = await res.json();
      if (data.status_code === 200) {
        setSuccess("Password updated successfully.");
        setPassword1("");
        setPassword2("");
        setTimeout(() => onClose(), 1200);
      } else {
        setError(data.message || "Failed to update password.");
      }
    } catch {
      setError("Failed to update password. Please try again.");
    }
  }

  if (!open) return null;

  return (
    <div className="login-modal-bg" style={{ zIndex: 9999 }}>
      <div className="login-card" style={{ minWidth: 320, maxWidth: 420, width: '90vw', padding: '2.2rem 2rem 2.2rem 2rem', position: 'relative', background: 'var(--color-modal-bg)', color: 'var(--color-modal-text)' }}>
        <button
          type="button"
          className="login-close-btn"
          aria-label="Close Reset Password Modal"
          onClick={onClose}
          style={{ right: '1.5rem', left: 'auto', top: '1.7rem', position: 'absolute' }}
        >
          <span style={{ fontFamily: 'Arial, sans-serif', fontWeight: 300, fontSize: '1.5em', lineHeight: 1 }}>×</span>
        </button>
        <h1 style={{ marginBottom: '0.7rem', fontSize: '2.1rem', fontWeight: 700, color: '#232323', letterSpacing: '0.5px', textAlign: 'center' }}>{t('Reset Password')}</h1>
        <div style={{ margin: '1.2rem 0 0.7rem 0', width: '100%' }}>
          <label style={{ fontWeight: 700, fontSize: '1.04rem', color: '#232323', marginBottom: '0.17rem', display: 'block' }}>{t('Enter new password')}</label>
          <input
            type="password"
            value={password1}
            onChange={e => setPassword1(e.target.value)}
            style={{ width: '100%', boxSizing: 'border-box', border: '1.7px solid #eee2c9', borderRadius: '0.6rem', padding: '0.72rem 1.2rem', fontSize: '1.05rem', background: '#fff', marginBottom: '1.1rem' }}
            autoFocus
          />
          <label style={{ fontWeight: 700, fontSize: '1.04rem', color: '#232323', marginBottom: '0.17rem', display: 'block' }}>{t('Re-type new password')}</label>
          <input
            type="password"
            value={password2}
            onChange={e => setPassword2(e.target.value)}
            style={{ width: '100%', boxSizing: 'border-box', border: '1.7px solid #eee2c9', borderRadius: '0.6rem', padding: '0.72rem 1.2rem', fontSize: '1.05rem', background: '#fff', marginBottom: '1.1rem' }}
          />
          {error && <div style={{ color: '#e53935', fontSize: '1rem', marginBottom: 8 }}>{error}</div>}
          {success && <div style={{ color: '#388e3c', fontSize: '1rem', marginBottom: 8 }}>{success}</div>}
          <button
            className="login-btn submit"
            style={{ background: '#1976d2', color: '#fff', fontWeight: 700, minWidth: 120, width: '100%', marginTop: 8, padding: '0.9rem 0' }}
            onClick={handleSavePassword}
          >
            {t('Save Password')}
          </button>
        </div>
      </div>
    </div>
  );
}
